import Swiper from "swiper";

import {
  getParentByClass,
  validateEmailInput,
  validateTeleInput,
} from "../../../resources/js/helper/helper";

(function () {
  const mbEmailFunnels = document.querySelectorAll(".mb-contact-funnel");

  for (let i = 0; i < mbEmailFunnels.length; i++) {
    /**
     * Init slider
     */
    const currentSwiper = new Swiper(mbEmailFunnels[i], {
      loop: false,
      slidesPerView: 1,
      allowTouchMove: false,
      on: {
        slideChange: function (swiper) {
          if (
            swiper.activeIndex > 0 &&
            swiper.activeIndex < swiper.slides.length - 1
          ) {
            swiper.el.classList.add("mb-contact-funnel-go-back");
          } else {
            swiper.el.classList.remove("mb-contact-funnel-go-back");
          }

          if (swiper.activeIndex == swiper.slides.length - 2) {
            swiper.el.classList.add("mb-contact-funnel-send");
          } else {
            swiper.el.classList.remove("mb-contact-funnel-send");
          }

          updateTabindexForSlides(swiper);
          focusActiveSlide(swiper);
          announceStep(swiper);
        },
        reachEnd: function (swiper) {
          swiper.el.classList.remove(
            "mb-contact-funnel-send",
            "mb-contact-funnel-go-back"
          );
          swiper.el.classList.add("mb-contact-funnel-end");
          updateTabindexForSlides(swiper);
          focusActiveSlide(swiper);
        },
        afterInit: function (swiper) {
          updateTabindexForSlides(swiper);
        },
      },
    });

    const currentSwiperEle = currentSwiper.el;
    const stepStatus = currentSwiperEle.querySelector(".mb-contact-funnel-step-status");

    const backButton = currentSwiper.el.querySelector(
      ".mb-contact-funnel-back"
    );
    const nextButton = currentSwiper.el.querySelector(
      ".mb-contact-funnel-next"
    );

    const sendButton = currentSwiper.el.querySelector(
      ".mb-contact-funnel-send"
    );

    /**
     * Disable tabindex on inputs in inactive slides, enable in active slide
     */
    function updateTabindexForSlides(swiper) {
      swiper.slides.forEach(function (slide, index) {
        const focusable = slide.querySelectorAll("input, textarea, button, a, select");
        if (index === swiper.activeIndex) {
          focusable.forEach(function (el) { el.removeAttribute("tabindex"); });
          slide.removeAttribute("aria-hidden");
        } else {
          focusable.forEach(function (el) { el.setAttribute("tabindex", "-1"); });
          slide.setAttribute("aria-hidden", "true");
        }
      });
    }

    /**
     * Move focus to the first focusable element in the active slide
     */
    function focusActiveSlide(swiper) {
      const activeSlide = swiper.slides[swiper.activeIndex];
      if (!activeSlide) return;
      const firstFocusable = activeSlide.querySelector("input, textarea, button, a, [tabindex]");
      if (firstFocusable) {
        // Defer focus until after Swiper transition
        setTimeout(function () { firstFocusable.focus(); }, 100);
      }
    }

    /**
     * Announce current step to screen readers via aria-live region
     */
    function announceStep(swiper) {
      if (!stepStatus) return;
      const totalInputSlides = swiper.slides.length - 1; // last slide is confirmation
      const current = swiper.activeIndex + 1;
      if (swiper.activeIndex < totalInputSlides) {
        stepStatus.textContent = "Schritt " + current + " von " + totalInputSlides;
      }
    }

    /**
     * Click BackButton
     */
    backButton.addEventListener("click", (e) => {
      currentSwiper.slidePrev();
    });

    /**
     * Click NextButton
     */
    nextButton.addEventListener("click", (e) => {
      const activeSlide = currentSwiper.slides[currentSwiper.activeIndex];
      const currentInputs = activeSlide.querySelectorAll("input, textarea");
      let goToNextStep = true;

      // check for required inputs on current slide
      for (let ci = 0; ci < currentInputs.length; ci++) {
        goToNextStep = validateInput(currentInputs[ci]) ? goToNextStep : false;
      }

      // go to next slide
      if (goToNextStep) currentSwiper.slideNext();
      else focusFirstInvalid(activeSlide);
    });

    /**
     * Enter key in input fields triggers next/send button
     */
    currentSwiperEle.addEventListener("keydown", (e) => {
      if (e.key !== "Enter") return;
      if (e.target.tagName === "TEXTAREA") return;

      const isSendVisible = currentSwiperEle.classList.contains("mb-contact-funnel-send");
      if (isSendVisible) {
        e.preventDefault();
        sendButton.click();
      } else if (!currentSwiperEle.classList.contains("mb-contact-funnel-end")) {
        e.preventDefault();
        nextButton.click();
      }
    });

    /**
     * Submit handler (prevents native form submission, delegates to sendButton logic)
     */
    currentSwiperEle.addEventListener("submit", (e) => {
      e.preventDefault();
      sendButton.click();
    });

    /**
     * Click sendButton
     */
    sendButton.addEventListener("click", (e) => {
      // check disabled state
      if (sendButton.classList.contains("disabled")) return;

      // check for required inputs on current slide
      const activeSlide = currentSwiper.slides[currentSwiper.activeIndex];
      const currentInputs = activeSlide.querySelectorAll("input, textarea");
      let couldBeSend = true;

      for (let ci = 0; ci < currentInputs.length; ci++) {
        couldBeSend = validateInput(currentInputs[ci]) ? couldBeSend : false;
      }

      // stop if input isn't valid
      if (!couldBeSend) {
        focusFirstInvalid(activeSlide);
        return;
      }

      sendButton.classList.add("disabled");
      sendButton.setAttribute("aria-disabled", "true");

      // get email content
      const allInputs = currentSwiperEle.querySelectorAll("input, textarea");
      let emailText = "";

      for (let ai = 0; ai < allInputs.length; ai++) {
        const value = allInputs[ai].value;
        const placeholder = allInputs[ai].placeholder;

        if (value) {
          emailText += placeholder + ": " + value + "\n";
        }
      }

      // send email
      jQuery.ajax({
        type: "POST",
        url: globalvars.ajaxurl,
        data: {
          action: "send_contact_mail_ajaxhandler",
          nonce: globalvars.ajax_nonce,
          text: emailText,
          to: sendButton.dataset.mailto,
        },
        beforeSend: function () {},
        complete: function () {},
        success: function (data) {
          sendButton.classList.remove("disabled");
          sendButton.removeAttribute("aria-disabled");
          currentSwiper.slideNext();
          if (stepStatus) stepStatus.textContent = "Ihre Nachricht wurde erfolgreich gesendet.";
        },
        error: function (MLHttpRequest, textStatus, errorThrown) {
          sendButton.classList.remove("disabled");
          sendButton.removeAttribute("aria-disabled");
          if (stepStatus) stepStatus.textContent = "Beim Senden ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.";
          console.log(textStatus, errorThrown);
        },
      });
    });

    /**
     * Move focus to first invalid field in a slide
     */
    function focusFirstInvalid(slide) {
      const firstInvalid = slide.querySelector(".mb-invalid-input");
      if (firstInvalid) firstInvalid.focus();
    }

    /**
     * Validation helper
     */
    function validateInput(input) {
      input.classList.remove("mb-invalid-input");
      input.removeAttribute("aria-invalid");

      const errorSpan = input.getAttribute("aria-describedby")
        ? document.getElementById(input.getAttribute("aria-describedby"))
        : null;

      if (errorSpan) errorSpan.textContent = "";

      let isValid = false;

      if (input.type == "email") {
        isValid = validateEmailInput(input);
      } else if (input.type == "tel") {
        isValid = validateTeleInput(input);
      } else {
        isValid =
          (input.required && input.value) || (!input.required && input.value);
      }

      const mbFormfield = getParentByClass(input, "mb-formfield");
      if (mbFormfield) {
        mbFormfield.classList.remove("mb-invalid-formfield");

        if (!isValid) {
          mbFormfield.classList.add("mb-invalid-formfield");
          const validationMessage = mbFormfield.dataset.validationMessage;
          if (errorSpan && validationMessage) {
            errorSpan.textContent = validationMessage;
          }
        }
      }

      if (!isValid) {
        input.classList.add("mb-invalid-input");
        input.setAttribute("aria-invalid", "true");
      }

      return isValid;
    }
  }
})();
